// 接口返回成功 code
export const SUCCESS_CODE = 0;
//# sourceMappingURL=constants.js.map